import envConfig from './env-config.json';
export const env = envConfig;
if (typeof document !== 'undefined' && !document.getElementById('gs1-wc-fouc-style')) {
    const style = document.createElement('style');
    style.id = 'gs1-wc-fouc-style';
    style.textContent = ':not(:defined){visibility:hidden}';
    document.head.appendChild(style);
}
//# sourceMappingURL=environment.js.map